import { Checkbox, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateManagePrescriptionSubmissionData } from "../../../actions/ManagePrescriptionAction";
import { AssetStore } from "../../../assets/AssetsStore";
import { BlackAdd, BlueAdd, ClockSmall } from "../../../assets/Logos/Icons";
import AddDataModal from "../../PrintPrescription/Components/Modals/AddDataModal/AddDataModal";
import { PrescriprionContext } from "../../PrintPrescription/PrintPrescription";
import Searchbox from "../SearchBox/Searchbox";
import styles from "./index.module.scss";

function InstructionBox({
  data,
  haveNote,
  name,
  addTitle,
  initialData,
  handleSearch,
  handleAdd,
  toggle,
}) {
  const [isAddOpen, setAddOpen] = useState(false);
  const [searchValues, setSearchValues] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const { wholeData:{instructions}, handleWholeData } = useContext(PrescriprionContext);
  const { wholeData } = useContext(PrescriprionContext);
  const [text, setText] = useState('');

  const { instruction_note } = useSelector(
    (state) => state?.managePrescription?.submissionData
  );

 
  let dispatch = useDispatch();

  useEffect(() => {
    setSearchValues(createSearchOptionsWithData(initialData));
    //pushToWholeData("instructions", initialData);
    
  }, [initialData]);

  const handleAddInstruction = (e) => {

    handleAdd(e);
    handleSelectData(e, true)
  };

  const handleSearchBox = (value) => {
    handleSelectData(value);
    handleSearch(value);
    setSelectedData([...selectedData, { name: value }]);
    isSelected(value);
   
    pushToWholeData("instructions", [...instructions, { name: value }]);
    setSearchValues(createSearchOptionsWithData(initialData));
  };

  const isInSearch = (e, data) => {
   
    for (let i = 0; i < e.length; i++) {

      if (e[i].toLowerCase() !== data?.name[i].toLowerCase()) {
        return false;
      }
    }
    return true;
  };

  const handleOnSearch = (e) => {
    if (initialData && initialData.length > 0 && e) {
      let filterData = initialData.filter((option) => isInSearch(e, option));
      setSearchValues(createSearchOptionsWithData(filterData));
    } else setSearchValues([]);
  };

  let handleNoteChange = (e) => {
    let { value } = e?.target;
    handleWholeData("instructionNote", value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        instruction_note: value,
      })
    );
  };

  const handleSelectData = (data, value) => {
    console.log(value, data);
    if(value){
      pushToWholeData("instructions", [...instructions, data]);
    }
    else{
      let filteredData= instructions.filter((item) => item?.name !== data?.name)
      pushToWholeData("instructions", filteredData);
    
    }
    // const isFound = selectedData.filter((item) => item === data).length
    //   ? true
    //   : false;
    // isFound
    //   ? setSelectedData(selectedData.filter((item) => item !== data))
    //   : setSelectedData([...selectedData, data]);
  };

  const pushToWholeData = (key, data) => {
    handleWholeData(key, data);
  };

  const instrunctiondate = (e) => {
    console.log("instrunctiondate",e.target.value)
    pushToWholeData("instructions", e.target.value);
  }


  const isSelected = (param) => {
    
    let { name } = param;
    let data = wholeData?.instructions;
  
    if (data && data.length > 0) {
      let res = data.filter((e) => e.name === name);
     
      return res && res.length > 0;
    }
  };

  const createSearchOptionsWithData = (data) => {
    if (data && data.length > 0) {
      let result = [];
      data.map((e) => result.push({ label: e?.name, value: e?.name }));
      return result;
    } else {
      return [];
    }
  };

   useEffect(() => {
     if (wholeData.instructions !="") {
      
       setText(wholeData.instructions)
     }
  }, [wholeData.instructions]);

  // useEffect(() => {
  //   if (selectedData.length > 0) {
  //     pushToWholeData("instructions", selectedData);
  //   }
  // }, [selectedData]);

  // const handleSubmissionData = (data) => {
  //   if (data) {
  //     setSelectedData(data);
  //   }
  // };

  // useEffect(() => {
  //   if (wholeData.instructions !== selectedData) {
  //     handleSubmissionData(wholeData.instructions);
  //   }
  // }, [wholeData.instructions]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    // Use a regular expression to allow only alphanumeric characters and spaces
   // const sanitizedValue = inputValue.replace(/[^A-Za-z0-9\s]/g, '');
    pushToWholeData("instructions", inputValue);
    setText(inputValue);
  };

  console.log("dddd",wholeData.instructionNote)
  return (
    <>
      <div className={styles.instruction_box_container}>
        {/* <div className={styles.header}>
          <div className={styles.searchBox}>
      

            <Searchbox
              readOnly={wholeData?.isViewMode}
              value={instructions}
              options={createSearchOptionsWithData(initialData)}
              onSelect={handleSearchBox}
              onSearch={handleOnSearch}
              placeholder="Search"
            />
          </div>

          {!wholeData?.isViewMode && (
            <button
              className={styles.add_new_button}
              onClick={() => {
                setAddOpen(true);
              }}
            >
              <span>Add new</span>
              <BlackAdd />
            </button>
          )}
        </div> */}

        <div className={styles.body}>
          {/* <div className={styles.caption}>
            <ClockSmall/>
                        {name}
          </div> */}

          <div className={styles.data_list}>
            <textarea placeholder="Type here" className={styles.txt_area}
            value={text}
            
              onChange={handleInputChange}
            ></textarea>
          </div>
        </div>

        
      </div>
      <AddDataModal
        onSubmit={(e) => {
          handleAdd && handleAddInstruction(e);
        }}
        title={addTitle ? addTitle : "Add new"}
        showModal={isAddOpen}
        hidemodal={() => {
          setAddOpen(false);
        }}
      />
    </>
  );
}

export default InstructionBox;
